import { useEffect } from "react";
import { useRouterState } from "@tanstack/react-router";
import { EVENT_SCROLL_DEPTH, pushEvent } from "@/lib/gtm-events";

/**
 * Stuurt één `scroll_depth`-event per pagina zodra de bezoeker 75% van de
 * pagina heeft gescrold. Zo ziet u in GA4 welke pagina's echt gelezen
 * worden in plaats van alleen bekeken.
 *
 * Parameters:
 *  - percent   Altijd 75 (vaste drempel)
 *  - page_path Pad waar gescrold werd
 */
export function ScrollDepthTracker() {
  const pathname = useRouterState({ select: (s) => s.location.pathname });

  useEffect(() => {
    if (typeof window === "undefined") return;
    let fired = false;

    const onScroll = () => {
      if (fired) return;
      const doc = document.documentElement;
      const scrollable = doc.scrollHeight - window.innerHeight;
      if (scrollable <= 0) return;
      if (window.scrollY / scrollable >= 0.75) {
        fired = true;
        pushEvent(EVENT_SCROLL_DEPTH, { percent: 75, page_path: pathname });
        window.removeEventListener("scroll", onScroll);
      }
    };

    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, [pathname]);

  return null;
}
